const dateFormatters = new Map<string, Intl.DateTimeFormat>()

function formatter(timeZone: string): Intl.DateTimeFormat {
  let f = dateFormatters.get(timeZone)
  if (!f) {
    f = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hourCycle: 'h23',
    })
    dateFormatters.set(timeZone, f)
  }
  return f
}

function parts(ms: number, timeZone: string) {
  const out: Record<string, string> = {}
  for (const p of formatter(timeZone).formatToParts(ms)) out[p.type] = p.value
  return out
}

/** 指定タイムゾーンでの日付を YYYY-MM-DD で返す */
export function localDate(ms: number, timeZone: string): string {
  const p = parts(ms, timeZone)
  return `${p.year}-${p.month}-${p.day}`
}

export function localHour(ms: number, timeZone: string): number {
  return Number(parts(ms, timeZone).hour) % 24
}

export function isValidTimeZone(tz: string): boolean {
  if (!tz) return false
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: tz })
    return true
  } catch {
    return false
  }
}

export function addDays(date: string, days: number): string {
  const [y, m, d] = date.split('-').map(Number)
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10)
}

/** 0 = 日曜 */
export function dayOfWeek(date: string): number {
  const [y, m, d] = date.split('-').map(Number)
  return new Date(Date.UTC(y, m - 1, d)).getUTCDay()
}
